/**
 * Constants related to NSFW (Not Safe For Work) moderation across the application
 */

/**
 * NUDITY detection threshold
 * Used by both frontend and backend to determine when content should be flagged
 * as potentially inappropriate based on confidence scores from AI models
 */
export const NUDITY_DETECTION_THRESHOLD = 0.97;
